import { containerTransactionConflictsOps } from "../../api/operations";
import dayjs from "dayjs";
import { entityFactory } from "../../hooks/useEntity";
import { ROLE } from "../../Auth/useRole";
import { ContainerTransactionConflictFilter } from "../../api/types";
import { shortTimeFormat } from "../../helpers/timeUtils";
import { defineEntity } from "../../api/entity";

const conf = defineEntity({
  ...entityFactory("transaction-conflicts"),
  endpoint: "container-transaction-conflicts",
  operations: containerTransactionConflictsOps,
  roleView: [ROLE.TRANSACTION_VIEW],
  roleAdmin: [],
  singularName: (t) => t("Transaction conflict"),
  name: (t) => t("Transaction conflicts"),
  disableCache: true,
  syncCustomerFilter: true,
  filterFormatter: ({ ...filter }: ContainerTransactionConflictFilter & { status: any }) => {
    return {
      ...filter,
      receivedFrom: filter?.receivedFrom ? dayjs(filter?.receivedFrom).utc().format(shortTimeFormat) : undefined,
      receivedTo: filter?.receivedTo ? dayjs(filter?.receivedTo).utc().format(shortTimeFormat) : undefined,
    };
  },

  initialFilter: {
    sortBy: "receivedOn",
    sortOrder: "descend",
    from: dayjs().subtract(1, "month").format(shortTimeFormat),
    to: dayjs().format(shortTimeFormat),
  },
});

export default conf;
